<template>
  <div class="title">
    <!--标题-->
    <p :class="{isLetterSpace: lang === 'zh'}">{{$t('title.' + content)}}</p>
    <!--向下的动态效果-->
    <div class="downBtn" @click="down">
      <span class="label"></span>
    </div>

  </div>
</template>

<script>

  import {reactive, ref, getCurrentInstance, onMounted} from "vue";
  import { useStore, mapGetters } from 'vuex'
  import bus from 'vue3-eventbus'  //引入事件总线

  export default {
    name: "Title",
    props:{
      content:{
        type: String,
        default:'',
      }
    },
    computed: {
      ...mapGetters(['showLang'])
    },//computed
    setup(){

      const store = useStore()
      let instance = reactive({});
      onMounted(() => {
        instance = getCurrentInstance();
      })



      //监听事件总线
      let lang = ref('')
      lang.value = store.state.language;
      bus.on('changeLang', type => lang.value = type);
      function down() {
      // 页面高度: window.innerHeight
      window.scrollTo(0, window.innerHeight / 2 - 106)
    }


    return{ down, lang

      }
    },//setup
  }
</script>

<style scoped lang="less">
  .title{
    position: absolute;
    top: 20%;
    left: 15%;
    p{
      font-size: 30px;
      color: #ffffff;
      line-height: 44px;

      text-shadow: rgb(0 0 0 / 50%) 2px 2px 5px;
    }
    .isLetterSpace { letter-spacing: 5px; }

    .downBtn{
      margin-top: 38px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 1px solid #fff;
      position: relative;
      cursor: pointer;
      //定义动画
      @keyframes myfirst
      {
        from { margin-top: 10%; opacity: 100%; }
        to { margin-top: 80%; opacity: 40%; }
      }
      @-webkit-keyframes myfirst /* Safari 与 Chrome */
      {
        from { margin-top: 10%; opacity: 100%; }
        to { margin-top: 100%; opacity: 40%; }
      }
      span{
        width: 13px;
        height: 7px;
        left: 50%;
        margin-left: -6px;
        background: url("~assets/img/common/down.jpg") no-repeat center;
        position: absolute;
        //-webkit-animation: gettop 1.2s infinite linear;
        //animation: gettop 1.2s infinite linear;
        animation: myfirst 1.5s infinite linear;
        -webkit-animation: myfirst 1.5s infinite linear; /* Safari 与 Chrome */
      }
    }
  }


</style>